import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import dot from 'dot/doT';

function BrowseBar() {
    this.defaultAttrs({
        filters: '[data-active-filters]',
        filter: '[data-filter-pill-open-drawer]',
        'filter-close': '[data-filter-pill-close-name]',
        'all-designs-pill': '[data-all-designs-pill]',
        'filter-template': '[data-browse-bar-filter-template]',
        'all-designs-template': '[data-all-designs-template]',
    });

    this.after('initialize', function() {
        this.on(document, 'uiMegaDrawerFilterChange', this.updateFilters);
        this.on('click', {
            filter: this.toggleMegaDrawerOpen,
            'filter-close': this.deactivateFilter,
            'all-designs-pill': this.toggleMegaDrawerDefault,
        });

        this.on(document, 'dataFilterChange', this.updateFilters);
    });

    this.updateFilters = function(event, data) {
        const self = this;
        let filtersHTML = '';
        const filters = data.filters;

        // FIXME: Use Object.keys
        for (const filterIndex in filters) {
            // eslint-disable-line
            const filter = filters[filterIndex];
            if (Array.isArray(filter)) {
                for (let i = 0, l = filter.length; i < l; i += 1) {
                    filtersHTML += self.buildButton({
                        category: filterIndex,
                        name: filter[i].title,
                        value: filter[i].value,
                    });
                }
            } else if (filterIndex !== 'page' && filter.value) {
                filtersHTML += self.buildButton({
                    category: filterIndex,
                    name: filter.title,
                    value: filter.value,
                });
            }
        }

        if (!filtersHTML) {
            filtersHTML = this.select('all-designs-template').html();
        }

        this.select('filters').html(filtersHTML);
    };

    this.buildButton = function(el) {
        const template = dot.template(this.select('filter-template').html());
        return template(el);
    };

    this.toggleMegaDrawerDefault = function() {
        $(document).trigger('uiMegaDrawerToggleDefault');
    };

    this.deactivateFilter = function(event, data) {
        // Stopping propagation to prevent body click closing the drawer
        event.stopPropagation();

        const filterName = $(data.el).attr('data-filter-pill-category');
        const filterTitle = $(data.el).attr('data-filter-pill-title');
        const filterValue = $(data.el).attr('data-filter-pill-close-name');

        this.trigger('uiRemoveFilters', {
            filters: [
                {
                    name: filterName,
                    title: filterTitle,
                    value: filterValue,
                },
            ],
        });
    };

    this.toggleMegaDrawerOpen = function(event, data) {
        const filterCategory = $(data.el).attr('data-filter-pill-category');
        $(document).trigger('uiMegaDrawerTogglePanel', { category: filterCategory });
        $(document).trigger('uiActivateSmallScreenOffCanvasFilters', { name: 'filters' });
    };
}

export default defineComponent(BrowseBar);



// WEBPACK FOOTER //
// ./src/js/component_ui/browse-bar.js